import React from "react";
import QurealRichEditor from "./QurealRichEditor";

const QurealBasicBubbleEditor = (props) => {
    return (
        <QurealRichEditor
            {...props}
            editorOptions={{
                includeTable: true,
                includeMedia: true,
                includeFormatting: true,
                includeAlignment: true,
            }}
            menuFeatures="basic"
            menuType="bubble"
        />
    );
};

export default QurealBasicBubbleEditor;
